import { render, staticRenderFns } from "./SubmitCertificateModal.vue?vue&type=template&id=c4b0bff2"
import script from "./SubmitCertificateModal.vue?vue&type=script&lang=js"
export * from "./SubmitCertificateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports